import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { LibSharedCommonModule } from '@solvace/common';
import { SvcBtnIconModule } from '@solvace/component/svc-btn-icon';
import { SvcButtonEllipsisComponent } from './svc-button-ellipsis.component';


@NgModule({
  declarations: [
    SvcButtonEllipsisComponent
  ],
  imports: [
    LibSharedCommonModule,
    SvcBtnIconModule,
    MatMenuModule,
    MatIconModule,
  ],
  exports: [
    SvcButtonEllipsisComponent
  ]
})
export class SvcButtonEllipsisModule { }
